// TODO: we need to use the color variables here in the future

export default {
  success: {
    barStyle: {
      lineHeight: "1.5",
      background: '#65EC83',
      color: '#2D2E2E'
    },
    actionStyle: {
      padding: '.5rem',
      border: '1px #2D2E2E solid',
      color: '#2D2E2E'
    }
  },
  error: {
    barStyle: {
      lineHeight: "1.5",
      background: '#F5726D',
      color: '#2D2E2E'
    },
    actionStyle: {
      padding: '.5rem',
      border: '1px #2D2E2E solid',
      color: '#2D2E2E'
    }
  },
  warning: {
    barStyle: {
      lineHeight: "1.5",
      background: '#FFF284',
      color: '#2D2E2E'
    },
    actionStyle: {
      padding: '.5rem',
      border: '1px #2D2E2E solid',
      color: '#2D2E2E'
    }
  },
  informational: {
    barStyle: {
      lineHeight: "1.5",
      background: '#67DAF0',
      color: '#2D2E2E'
    },
    actionStyle: {
      padding: '.5rem',
      border: '1px #2D2E2E solid',
      color: '#2D2E2E'
    }
  }
}
